import React from 'react'
import TableRowCell from './TableRowCell'
import { OverlayTrigger } from 'react-bootstrap'
import { getTablePopover } from '../../../utils/appTableUtil/AppTableUtil'
import { ATTableRow } from './ATTableProps'

const TableRow: React.FC<ATTableRow> = ({
  data,
  columns,
  handleRowSelected,
  highlightSelectedRow = false,
  selectedRow,
  selectedRowAttribute,
  popoverMessage = '',
}) => {
  return (
    <>
      {data?.map((item, itemIndex: number) => (
        <OverlayTrigger
          key={`key-${itemIndex}`}
          placement="top"
          overlay={getTablePopover(item, popoverMessage)}
        >
          <tr
            className={`
            ${
              !item?.isActive && highlightSelectedRow
                ? 'inactive-back-ground'
                : ''
            } ${
              selectedRowAttribute &&
              selectedRow &&
              selectedRow[selectedRowAttribute] ===
                item[selectedRowAttribute] &&
              'selected-back-ground'
            } `}
            key={`table-body-${itemIndex}`}
            onClick={() => handleRowSelected?.(item, itemIndex)}
          >
            {columns.map((column, columnIndex: number) => (
              <TableRowCell
                key={`table-row-cell-${columnIndex}`}
                item={item}
                column={column}
              />
            ))}
          </tr>
        </OverlayTrigger>
      ))}
    </>
  )
}
export default TableRow
